//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SocialAccountAvatar',
  props: {
    socialAccount: {
      type: Object
    },
    size: {
      type: Number,
      default: 32
    },
    includeIcon: {
      type: Boolean,
      default: true
    }
  }
}
